/** Unified OTP API helpers — maps to solutions-dashboard POST /otp/* routes. */

import type { ApiParams } from "../api/fetch";

type OtpApiCaller = (path: string, params: ApiParams) => Promise<any>;

export const OTP_PURPOSE = {
  SIGNUP: "signup",
  MANAGING_SERVICES: "managing_services",
  UPDATING_IP_LIST: "updating_ip_list",
  UPDATE_APP: "update_app",
  MANAGING_APP_KEYS: "managing_app_keys",
  MANAGING_ZPIN: "managing_zpin",
} as const;

function signupAuthHeaders(signupToken: string) {
  return { Authorization: `Bearer ${signupToken}` };
}

async function postOtp(
  callApi: OtpApiCaller,
  path: "/otp/send" | "/otp/resend" | "/otp/validate",
  data: Record<string, unknown>,
  headers?: Record<string, string>
) {
  return callApi(path, {
    method: "POST",
    data,
    ...(headers && { headers }),
  });
}

export async function sendSignupOtp(
  callApi: OtpApiCaller,
  email: string,
  isConsentProvided: boolean
) {
  return postOtp(callApi, "/otp/send", {
    purpose: OTP_PURPOSE.SIGNUP,
    email,
    is_consent_provided: isConsentProvided,
  });
}

export async function resendSignupOtp(
  callApi: OtpApiCaller,
  email: string,
  signupToken: string
) {
  return postOtp(
    callApi,
    "/otp/resend",
    {
      purpose: OTP_PURPOSE.SIGNUP,
      email,
    },
    signupAuthHeaders(signupToken)
  );
}

export async function validateSignupOtp(
  callApi: OtpApiCaller,
  params: { email: string; relayId: string; otp: string; signupToken: string }
) {
  return postOtp(
    callApi,
    "/otp/validate",
    {
      purpose: OTP_PURPOSE.SIGNUP,
      email: params.email,
      relay_id: params.relayId,
      otp: params.otp,
    },
    signupAuthHeaders(params.signupToken)
  );
}

/** Session OTP for dashboard actions (IP whitelist, ZPIN, app keys). Purpose is the relay email label. */
export async function sendAuthOtp(callApi: OtpApiCaller, purpose: string) {
  return postOtp(callApi, "/otp/send", { purpose });
}
